import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selectOverlayState = (state: RootState) => state.overlayV2.overlay;
export const selectIsBoardLocked = (state: RootState) => state.overlayV2.overlay.isBoardLocked;
export const selectIsHideControlPanel = (state: RootState) => state.overlayV2.overlay.isHideControlPanel;
export const selectEvents = createSelector([selectOverlayState], (state) => state.events);
export const selectActiveEventId = createSelector([selectOverlayState], (state) => state.activeEventId);
export const selectPopups = createSelector([selectOverlayState], (state) => state.popups);
export const selectPopupIsLoaded = createSelector([selectOverlayState], (state) => state.popupIsLoaded);
export const selectIsMatchAvailable = (state: RootState) => state.overlayV2.overlay.isMatchAvailable;
export const selectIsBroadcastInitialized = (state: RootState) => state.overlayV2.overlay.isBroadcastInitialized;
export const selectIsMatchDataReady = (state: RootState) => state.overlayV2.overlay.isMatchDataReady;
export const selectPassedEventsId = (state: RootState) => state.overlayV2.overlay.passedEventsId;
export const selectBroadCastState = createSelector([selectOverlayState], (state) => {
  return {
    broadcastId: state.broadcastId,
    deviceId: state.deviceId,
    tournamentId: state.tournamentId,
    championshipId: state.championshipId,
    matchId: state.matchId,
    templateId: state.templateId,
  };
});
